import { render, staticRenderFns } from "./actMaleRank.vue?vue&type=template&id=eff490a6&scoped=true"
import script from "./actMaleRank.vue?vue&type=script&lang=js"
export * from "./actMaleRank.vue?vue&type=script&lang=js"
import style0 from "./actMaleRank.vue?vue&type=style&index=0&id=eff490a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff490a6",
  null
  
)

export default component.exports